import { ComponentRef } from '@wix/editor-platform-sdk-types';
import { ControllerType, EditorAppContext } from './types';
import {
  getControllerConnectedComponents,
  getControllersByType,
} from './editorSDKHelpers';
import { isSearchButton } from './searchButton';

export async function getConnectedSearchButtons(appContext: EditorAppContext) {
  const controllerRefs = await getControllersByType(
    appContext,
    ControllerType.SearchButton,
  );
  const connectedSearchBoxes: ComponentRef[] = [];

  for (const controllerRef of controllerRefs) {
    const connectedComponentsRefs = await getControllerConnectedComponents(
      appContext,
      controllerRef,
    );

    for (const componentRef of connectedComponentsRefs) {
      if (await isSearchButton(appContext, componentRef)) {
        connectedSearchBoxes.push(componentRef);
      }
    }
  }
  return connectedSearchBoxes;
}
